import type { z } from 'zod';

import { fileQuerySchema } from './file-query-schema';

export const fileMutationSchema = fileQuerySchema.pick({ id: true });

export type FileMutationSchema = z.infer<typeof fileMutationSchema>;
